import React from 'react';
import './Footer.css'; // Create this CSS file for styling

const Footer = () => {
  return (
    <footer className="simple-footer">
      <div className="footer-content">
        <p>&copy; {new Date().getFullYear()} Rishi Shinde. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;